window.chmClipboard = (function() {
    let _this;

    function isNativeMode() {
        return false;
    }

    function isAppMode() {
        return ScoreTrekBattle.Session.isAppMode();
    }

    _this = {
        copy: function(text) {
            return new Promise((resolve, reject) => {
                if (isNativeMode()) {
                    window.Capacitor.Plugins.Clipboard.write({
                        string: text
                    }).then(() => {
                        resolve();
                    }).catch(error => {
                        console.warn(error);
                        reject();
                    });

                    return;
                }

                if (isAppMode()) {
                    Api.toApp('copy', {text: text}).then(isCopied => {
                        if (isCopied) {
                            resolve();
                        } else {
                            reject();
                        }
                    });

                    return;
                }
                
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(text).then(() => {
                        resolve();
                    }).catch(error => {
                        console.warn(error);
                        reject();
                    });

                    return;
                }
                
                reject('INVALID_MODE');
            });
        },

        paste: function() {
            return new Promise((resolve, reject) => {
                if (isNativeMode()) {
                    window.Capacitor.Plugins.Clipboard.read().then(result => {
                        resolve(result.value || '');
                    }).catch(error => {
                        console.warn(error);
                        reject();
                    });

                    return;
                }

                if (isAppMode()) {
                    Api.toApp('paste').then(text => {
                        resolve(text || '');
                    });

                    return;
                }
                
                if (navigator.clipboard && navigator.clipboard.readText) {
                    navigator.clipboard.readText().then(text => {
                        resolve(text || '');
                    }).catch(() => {
                        reject();
                    });

                    return;
                }
                
                reject('INVALID_MODE');
            });
        }
    };

    return _this;
})();
